import { render, staticRenderFns } from "./AddEquipos.vue?vue&type=template&id=63d7bc76&"
import script from "./AddEquipos.vue?vue&type=script&lang=ts&"
export * from "./AddEquipos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports